
<!-- start : duplicate value popup -->
<div class="modal fade" id="duplicateValuePopUp">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header text-center"> <b>Duplicats are present for this field</b></div>
        <div class="modal-body">
            <div style="margin-top: 15px;margin-bottom: 15px;">
                <p>Duplicates are already present for this field. Please contact <a href="mailto:contact@forushealth.com">contact@forushealth.com</a> to remove the duplicates. However, If you choose this field as "Unique Value" then only unique values will be allowed for new entries.</p>
            </div>
            <div class="table-responsive">
            <table class="table table-bordered">
                <tbody>
                <tr><th>Value</th><th>Duplicates</th></tr>
                <tr *ngFor="let itr of duplicatesPresent"><td>{{itr.fieldValue}}</td><td>{{itr.duplicates}}</td></tr>
                </tbody>
            </table>
            </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-sm btn-danger" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
  <!-- end : duplicate value popup -->


<div class="tile-progress bg-white text-left col-lg-12">
    <div class="col-lg-4" style="padding-left: 0%;" *ngIf="!roleType">
        <label>Select Account</label>
        <ng-select [items]="accounts" (change)="getCustomFieldsByAccountId()" name="accounts" bindLabel="accountName"
            [clearable]="true" [searchable]="true" bindValue="accountId" [(ngModel)]="accountId" placeholder="Select account">
        </ng-select>
    </div>
    <div class="col-lg-4" *ngIf="roleType">
        <label>Select Service Provider</label>
        <ng-select [items]="serviceProviders" (change)="getCustomFieldsByAccountId()" name="serviceProvider"
            bindLabel="name" [clearable]="true" [searchable]="true" bindValue="id" [(ngModel)]="serviceProviderId"
            placeholder="Select service provider">
        </ng-select>
    </div>
    <div class="col-lg-4" *ngIf="(accounts!=null && accountId>0) || (serviceProviders!=null && serviceProviderId>0)">
        <label>Select Module</label>
        <ng-select [items]="modules" bindLabel="label" bindValue="id"
            (change)="getCustomFieldsByAccountId();initializeDefaultTemplate(moduleId)" name="modules"
            [clearable]="true" [searchable]="true" bindValue="id" [(ngModel)]="moduleId" placeholder="Select module">
        </ng-select>
    </div>
    <div class="col-lg-4">
        <label >Select Type</label>
        <br>
        <div style="float:left;margin-right:5px">
            <label class="switch">
                <input type="checkbox" [(ngModel)]="roleType" (change)="onSelectRoleType(roleType)">
                <div class="slider">
                    <span class="on" style="color:white;width:fit-content;font-size: 14px;padding-right: 30px;">Reading Center</span>
                    <span class="off" style="color:white;width:fit-content;font-size: 14px;">Account</span>
                </div>
            </label>
        </div>

    </div>
</div>
<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " style="padding-left:0px;padding-right:0px"
    *ngIf="(accounts!=null && accountId>0 && modules!=null && moduleId!=null) || (serviceProviderId!=null && serviceProviderId>0 && modules!=null && moduleId!=null)">

    <div class="card-header">
        Add Custom Fields
        <button class="btn btn-sm btn-primary float-right"
            style="margin-top: -4px;margin-left: 4px;background-color:rgb(87,200,231)" (click)="addNewRow('field',null)">
            <span>
                <i class="fa fa-plus-circle" style="margin-top:6px;color:#fff;"></i> Add New Field</span>
        </button>
        <button class="btn btn-sm btn-warning float-right"
            style="margin-top: -4px; margin-left: 4px;background-color:#21618C" (click)="addNewRow('section',null)"
            [disabled]="moduleId=='ADDRESS'">
            <span style="color:white">
                <i class="fa fa-plus-circle" style="margin-top:6px;color:white;"></i> Add New Section</span>
        </button>
        <button class="btn btn-sm btn-warning float-right"
            style="margin-top: -4px; margin-left: 4px;background-color:#566573" data-toggle="modal"
            data-target="#previewCustomFieldModal" (click)="getAllActiveFields()">
            <span>
                <i class="fa fa-eye" style="margin-top:6px;color:#fff;"></i> Preview Page</span>
        </button>
        <button class="btn btn-sm btn-warning float-right"
            style="margin-top: -4px; margin-left: 4px;background-color:rgb(249,190,0);color:white" (click)="resetPage()">
            <span>
                <i class="fa fa-fw fa-lg fa-undo" style="margin-top:6px;color:white;"></i> Reset Page</span>
        </button>
    </div>
    <!--preview pop up-->
    <div class="modal fade" id="previewCustomFieldModal" role="dialog">
        <div class="modal-dialog" style="width:80%;height:auto">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                    <h4 class="modal-title">{{moduleId}} Custom Fields Preview [Alignment Of Fields]</h4>
                </div>
                <div class="modal-body" style="height:auto;overflow-y:scroll">

                    <div class="panel" style="margin-top:10px">
                        <div class="panel-heading" style="background:#fbfbfb;" *ngIf="moduleId=='Patient'">
                            <div style="color: rgb(45, 90, 160);font-size:14px">Register New Patient
                            </div>
                        </div>
                        <div class="panel-body" style="padding:0px; margin-top:20px;">
                            <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6"
                                *ngFor="let itr of activeCustomFieldConfig.customFields ; let i=index">
                                <div *ngIf="itr.fieldType=='Text Box' " style="height:70px">
                                    <div><label style="font-weight:normal">{{itr.fieldName}}</label><label
                                            style="font-weight:normal" *ngIf="itr.isMandatory==true">*</label></div>
                                    <div style="margin-top:10px"><input type="text" class="form-control"
                                            name="itr.fieldName" id="text_itr.fieldName_{{i}}"
                                            style="border:1px solid #dde6e9;height:35px" />
                                    </div>
                                </div>
                                <div *ngIf="itr.fieldType=='Number' " style="height:70px">
                                    <div><label style="font-weight:normal">{{itr.fieldName}}</label><label
                                            style="font-weight:normal" *ngIf="itr.isMandatory==true">*</label></div>
                                    <div style="margin-top:10px"><input type="text" class="form-control"
                                            name="itr.fieldName" id="number_itr.fieldName_{{i}}"
                                            style="border:1px solid #dde6e9;height:35px" />
                                    </div>
                                </div>
                                <div *ngIf="itr.fieldType=='Radio Button' " style="height:70px">
                                    <div><label style="font-weight:normal">{{itr.fieldName}}</label><label
                                            style="font-weight:normal" *ngIf="itr.isMandatory==true">*</label></div>
                                    <label *ngFor="let radioOptions of itr.fieldOptions.split(','); let j=index"
                                        style="font-weight:normal;margin-top:10px;margin-right:30px">
                                        <input type="radio"
                                            style="margin-left: 0px; margin-right: 5px;width: 1.5em;vertical-align: middle;"
                                            name="{{itr.fieldName}}" value="{{radioOptions}}"
                                            id="radio_itr.fieldName_{{j}}" />
                                        {{radioOptions}}</label>
                                </div>
                                <div *ngIf="itr.fieldType=='Check Box'" style="height:70px">
                                    <div><label style="font-weight:normal">{{itr.fieldName}}</label><label
                                            style="font-weight:normal" *ngIf="itr.isMandatory==true">*</label></div>
                                    <div class="chiller_cb"
                                        *ngFor="let checkboxOptions of itr.fieldOptions.split(',');let j=index"
                                        style="float:left;margin-left: 0px; margin-right: 30px;margin-top:10px">
                                        <input id="checkbox_itr.fieldName_{{j}}" name="checkbox_itr.fieldName"
                                            value="{{checkboxOptions}}" type="checkbox" class="form-control" />
                                        <label style="font-weight: normal;"
                                            for="checkbox_itr.fieldName_{{j}}">{{checkboxOptions}}</label>
                                        <span style="border:1px solid #dde6e9;"></span>
                                    </div>
                                    <br><br>
                                </div>
                                <div *ngIf="itr.fieldType=='Drop Down'" style="height:70px">
                                    <div><label style="font-weight:normal">{{itr.fieldName}}</label><label
                                            style="font-weight:normal" *ngIf="itr.isMandatory==true">*</label></div>
                                    <select name="{{itr.fieldName}}" class="form-select form-select-sm"
                                        style="border:1px solid #dde6e9;height:35px;margin-top:10px">
                                        <option value="" disabled>Select {{itr.fieldName}} </option>
                                        <option value="{{dropdownOptions}}"
                                            *ngFor="let dropdownOptions of itr.fieldOptions.split(',')">
                                            {{dropdownOptions}} </option>
                                    </select>
                                </div>
                                <div *ngIf="itr.fieldType=='Text Area' " style="height:70px">
                                    <div><label style="font-weight:normal">{{itr.fieldName}}</label><label
                                            style="font-weight:normal" *ngIf="itr.isMandatory==true">*</label></div>
                                    <div style="margin-top:10px"><textarea rows="1" class=""
                                            style="border:1px solid #dde6e9;height:40px;width:100%"></textarea>
                                    </div>
                                </div>
                                <div *ngIf="itr.fieldType=='Multiselect' " style="height:70px">
                                    <div><label style="font-weight:normal">{{itr.fieldName}}</label><label
                                            style="font-weight:normal" *ngIf="itr.isMandatory==true">*</label></div>
                                    <div style="margin-top:10px">
                                        <angular2-multiselect class="form-control" [data]="itr.multiSelectOptions">
                                        </angular2-multiselect>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="panel" *ngFor="let customSections of  activeCustomFieldConfig.sections">
                        <div class="panel-heading"
                            [ngStyle]="{'color':customSections.titleTextColor,'background-color':customSections.titleBgColor}">
                            <div>{{customSections.sectionName}}
                            </div>
                        </div>
                        <div class="panel-body" style="padding:0px;margin-top:20px">
                            <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6"
                                *ngFor="let itr of customSections.customFields ; let sectionFieldIndex=index"
                                id="sectionFieldIndex_{{sectionFieldIndex}}">

                                <div *ngIf="itr.fieldType=='Text Box' " style="height:70px">
                                    <div><label style="font-weight:normal">{{itr.fieldName}}</label><label
                                            style="font-weight:normal" *ngIf="itr.isMandatory==true">*</label></div>
                                    <div style="margin-top:10px"><input type="text" class="form-control"
                                            name="text_itr.fieldName" id="text_itr.fieldName_{{$index}}"
                                            style="border:1px solid #dde6e9;height:35px" /></div>

                                </div>
                                <div *ngIf="itr.fieldType=='Number' " style="height:70px">
                                    <div><label style="font-weight:normal">{{itr.fieldName}}</label><label
                                            style="font-weight:normal" *ngIf="itr.isMandatory==true">*</label></div>
                                    <div style="margin-top:10px"><input type="text" class="form-control"
                                            name="number_itr.fieldName" id="number_itr.fieldName_{{$index}}"
                                            style="border:1px solid #dde6e9;height:35px" /></div>

                                </div>
                                <div *ngIf="itr.fieldType=='Radio Button' " style="height:70px">
                                    <div><label style="font-weight:normal">{{itr.fieldName}} </label><label
                                            style="font-weight:normal" *ngIf="itr.isMandatory==true">*</label></div>
                                    <div style="margin-top:10px;margin-right:30px"><label
                                            *ngFor="let radioOptions of  itr.fieldOptions.split(','); let j=index"
                                            style="font-weight:normal;">
                                            <input type="radio"
                                                style="margin-left: 5px; margin-right: 5px;width: 1.5em;vertical-align: middle;"
                                                name="{{itr.fieldName}}" value="{{radioOptions}}"
                                                id="radio_itr.fieldName_{{j}}" />
                                            {{radioOptions}}</label>
                                    </div>
                                </div>
                                <div *ngIf="itr.fieldType=='Check Box' " style="height:70px">
                                    <div><label style="font-weight:normal">{{itr.fieldName}} </label><label
                                            style="font-weight:normal" *ngIf="itr.isMandatory==true">*</label></div>
                                    <div class="chiller_cb"
                                        *ngFor="let checkboxOptions of itr.fieldOptions.split(',');let j=index"
                                        style="float:left;margin-left: 0px; margin-right: 30px;;margin-top:10px">
                                        <input id="checkbox_itr.fieldName_{{j}}" name="checkbox_itr.fieldName"
                                            value="{{checkboxOptions}}" type="checkbox" class="form-control" />
                                        <label style="font-weight: normal;"
                                            for="checkbox_itr.fieldName_{{j}}">{{checkboxOptions}}</label>
                                        <span style="border:1px solid #dde6e9;"></span>
                                    </div>
                                </div>
                                <div *ngIf="itr.fieldType=='Drop Down' " style="height:70px">
                                    <div><label style="font-weight:normal">{{itr.fieldName}}</label><label
                                            style="font-weight:normal" *ngIf="itr.isMandatory==true">*</label></div>
                                    <div style="margin-top:10px"><select style="border:1px solid #dde6e9;height:35px"
                                            name="{{itr.fieldName}}" class="form-select form-select-sm" ng-required="itr.isMandatory">
                                            <option value="" disabled>Select {{itr.fieldName}} </option>
                                            <option value="{{dropdownOptions}}"
                                                *ngFor="let dropdownOptions of itr.fieldOptions.split(',');let j=index">
                                                {{dropdownOptions}} </option>
                                        </select></div>
                                </div>
                                <div *ngIf="itr.fieldType=='Text Area' " style="height:70px">
                                    <div><label style="font-weight:normal">{{itr.fieldName}}</label><label
                                            style="font-weight:normal" *ngIf="itr.isMandatory==true">*</label></div>
                                    <div style="margin-top:10px"><textarea rows="1" class=""
                                            style="border:1px solid #dde6e9;height:40px;width:100%"></textarea>
                                    </div>
                                </div>
                                <div *ngIf="itr.fieldType=='Multiselect' " style="height:70px">
                                    <div><label style="font-weight:normal">{{itr.fieldName}}</label><label
                                            style="font-weight:normal" *ngIf="itr.isMandatory==true">*</label></div>
                                    <div style="margin-top:10px">
                                        <angular2-multiselect class="form-control" [data]="itr.multiSelectOptions">
                                        </angular2-multiselect>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <!--Submit button-->
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div class="col-xs-12 text-center mTop15">
                            <button data-dismiss="modal" style="margin-right: 5px;" [disabled]="disableButtonFlag"
                                (click)="onSubmit()" class="btn btn-sm btn-success marginLR5">
                                <i class="fa fa-fw fa-lg fa-check-circle"></i> Save Customized Fields</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End of pop - up code-->
    <div class="content-body padding-top-20 padding-bottom-20" style="padding-bottom: 0px !important;">
        <div class="row">
            <div class="col-md-12 col-sm-12 col-xs-12" style="padding-left: 0px;padding-right: 0px;">
                <table class="table table-border-yellow">
                    <tbody [sortablejs]="customFieldConfig.customFields" [sortablejsOptions]="draggableOptions">
                        <tr *ngFor="let itr of customFieldConfig.customFields  ; let fieldIndex=index"
                            [class.draggable]="true" [class.disabled]="false">
                            <td class="form-group" style="padding-left: 0px;padding-right: 0px;">
                                <div class="form-group col-lg-3 col-md-4 col-sm-4 col-xs-12"><input
                                        [(ngModel)]="itr.fieldName" type="text" class="form-control" required
                                        placeholder="Field name" (blur)="checkUniqueField(itr.fieldName,null)"
                                        (keyup)="disableButton()" #fieldNameModel="ngModel" name="fieldNameModel"
                                        id="fieldNameModel">
                                    <p [hidden]="fieldNameModel.valid || fieldNameModel.pristine" class="danger-text">
                                        *required</p>
                                </div>
                                <div class="form-group col-lg-3 col-md-4 col-sm-4 col-xs-12"><select
                                        [(ngModel)]="itr.fieldType" class="form-select form-select-sm" required
                                        placeholder="Field type" (change)="disableButton()" #fieldTypeModel="ngModel"
                                        name="fieldTypeModel" id="fieldTypeModel">
                                        <!--<option *ngIf="itr.fieldType!=null">{{itr.fieldType}}</option>-->
                                        <option [hidden]="moduleId!='REFRACTION'" *ngFor="let ft of refractionFieldTypes; let j=index">{{ft}}</option><!--show field types only for refraction module-->
                                        <option [hidden]="moduleId=='REFRACTION'" *ngFor="let ft of fieldTypes; let j=index">{{ft}}</option><!--show field types other than for refraction module-->
                                    </select>
                                    <p [hidden]="fieldTypeModel.valid || fieldTypeModel.pristine" class="danger-text">
                                        *required</p>
                                </div>
                                <div *ngIf="itr.fieldType=='Drop Down' || itr.fieldType=='Check Box' || itr.fieldType=='Radio Button' || itr.fieldType=='Multiselect'"
                                    class="form-group col-lg-3 col-md-4 col-sm-4 col-xs-12">
                                    <input type="text" class="form-control" placeholder="Enter comma seperated values"
                                        [(ngModel)]="itr.fieldOptions" (keyup)="disableButton()" required>
                                </div>
                                <div class="form-group col-lg-3 col-md-4 col-sm-4 col-xs-12">
                                    <div class="chiller_cb">
                                        <input id="isMandatory_{{fieldIndex}}" [(ngModel)]="itr.isMandatory"
                                            name="isMandatory_{{fieldIndex}}" type="checkbox" class="form-control" />
                                        <label style="font-weight: normal;"
                                            for="isMandatory_{{fieldIndex}}">Mandatory</label>
                                        <span></span>
                                    </div>

                                </div>
                                <div class="form-group col-lg-3 col-md-4 col-sm-4 col-xs-12"><input type="text"
                                        [(ngModel)]="itr.regex" placeholder="Regex" class="form-control" /></div>
                                <div class="form-group col-lg-3 col-md-4 col-sm-4 col-xs-12"><input type="number"
                                        [(ngModel)]="itr.minLength" class="form-control" min=0 placeholder="Min length"
                                        (keyup)="validateLength(itr.minLength,itr.maxLength)" /></div>
                                <div class="form-group col-lg-3 col-md-4 col-sm-4 col-xs-12"><input type="number"
                                        [(ngModel)]="itr.maxLength" class="form-control" min=0 placeholder="Max length"
                                        (keyup)="validateLength(itr.minLength,itr.maxLength)" /></div>
                                <div class="form-group col-lg-3 col-md-4 col-sm-4 col-xs-12"
                                    *ngIf="moduleId=='Patient' || moduleId=='ADDRESS'">
                                    <div class="chiller_cb">
                                        <input id="isSearchable_{{fieldIndex}}" [(ngModel)]="itr.isSearchable"
                                            name="isSearchable_{{fieldIndex}}" type="checkbox" class="form-control" />
                                        <label style="font-weight: normal;"
                                            for="isSearchable_{{fieldIndex}}">Searchable</label>
                                        <span></span>
                                    </div>
                                </div>
                                <div class="form-group col-lg-3 col-md-4 col-sm-4 col-xs-12"
                                    *ngIf="moduleId=='Patient'">
                                    <div class="chiller_cb">
                                        <input id="isConfidential_{{fieldIndex}}" [(ngModel)]="itr.isConfidential"
                                            name="isConfidential_{{fieldIndex}}" type="checkbox" class="form-control" />
                                        <label style="font-weight: normal;"
                                            for="isConfidential_{{fieldIndex}}">Confidential</label>
                                        <span></span>
                                    </div>
                                </div>
                                <div class="form-group col-lg-3 col-md-4 col-sm-4 col-xs-12"
                                    *ngIf="moduleId=='Patient'">
                                    <div class="chiller_cb">
                                        <input id="isUnique{{fieldIndex}}" [(ngModel)]="itr.isUnique"
                                            name="isUnique{{fieldIndex}}" type="checkbox" class="form-control" (ngModelChange)="isDuplicatePresent(itr)"/>
                                        <label style="font-weight: normal;"
                                            for="isUnique{{fieldIndex}}">Unique Value</label>
                                        <span></span>
                                    </div>
                                </div>
                                <div class="form-group col-lg-3 col-md-4 col-sm-4 col-xs-12"
                                    *ngIf="moduleId=='EXPERT_FUNDUS' || moduleId == 'REFRACTION' ">
                                    <div class="chiller_cb">
                                        <input id="includeInReport_{{fieldIndex}}" [(ngModel)]="itr.includeInReport"
                                            name="includeInReport_{{fieldIndex}}" type="checkbox"
                                            class="form-control" />
                                        <label style="font-weight: normal;" for="includeInReport_{{fieldIndex}}">Include
                                            In Report</label>
                                        <span></span>
                                    </div>
                                </div>
                                <div class="form-group col-lg-3 col-md-4 col-sm-4 col-xs-12"><select
                                        [(ngModel)]="itr.deviceType" class="form-select form-select-sm" placeholder="Device type"
                                        (change)="disableButton()" #deviceTypeModel="ngModel" name="deviceTypeModel"
                                        id="deviceTypeModel">
                                        <option *ngFor="let dt of deviceTypes; let j=index" [ngValue]="dt.value">
                                            {{dt.name}}</option>
                                    </select>
                                </div>
                                <div class="form-group col-lg-3 col-md-4 col-sm-4 col-xs-12"
                                    *ngIf="moduleId=='Patient'"><select [(ngModel)]="itr.fieldIdentity"
                                        class="form-select form-select-sm" placeholder="Field identity">
                                        <option *ngFor="let fi of fieldIdentities; let j=index" [ngValue]="fi.value">
                                            {{fi.name}}</option>
                                    </select>
                                </div>
                                <div class="form-group col-lg-3 col-md-4 col-sm-4 col-xs-12"
                                    *ngIf="moduleId=='REFRACTION'"><select [(ngModel)]="itr.fieldIdentity"
                                        class="form-select form-select-sm" placeholder="Field identity">
                                        <option *ngFor="let fi of refractionFieldIdentities; let j=index" [ngValue]="fi.value">
                                            {{fi.name}}</option>
                                    </select>
                                </div>
                                <div class="form-group col-lg-3 col-md-4 col-sm-4 col-xs-12"
                                    *ngIf="moduleId=='DOAAS'"><select [(ngModel)]="itr.fieldIdentity"
                                        class="form-select form-select-sm" placeholder="Field identity">
                                        <option *ngFor="let fi of teleOptometryFieldIdentities; let j=index" [ngValue]="fi.value">
                                            {{fi.name}}</option>
                                    </select>
                                </div>
                                 <div class="form-group col-lg-3 col-md-4 col-sm-4 col-xs-12"
                                    *ngIf="moduleId=='Referral'"><select [(ngModel)]="itr.fieldIdentity"
                                        class="form-select form-select-sm" placeholder="Field identity">
                                        <option *ngFor="let fi of spectacleOrderFieldIdentities; let j=index" [ngValue]="fi.value">
                                            {{fi.name}}</option>
                                    </select>
                                </div>
                                <div class="form-group col-lg-3 col-md-4 col-sm-4 col-xs-12"><select
                                        [(ngModel)]="itr.parentFieldId" class="form-select form-select-sm" placeholder="Parent field">
                                        <option value="null">
                                            Select parent field</option>
                                        <option *ngIf="fieldIndex>0"
                                            [ngValue]="(fieldIndex>0)?((customFieldConfig.customFields[fieldIndex-1].id==null)?customFieldConfig.customFields[fieldIndex-1].fieldName:customFieldConfig.customFields[fieldIndex-1].id):null">
                                            {{customFieldConfig.customFields[fieldIndex-1].fieldName}}</option>
                                    </select>
                                </div>
                            
                               
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin-top: 12px;text-align: center;">
                                    <button class="btn btn-sm btn-danger marginLR5" *ngIf="itr.status"
                                        (click)="removeRow(fieldIndex,'delete','field',null)"
                                        style="margin-top: 20px;margin-bottom: 11px;width:189px;"><i class="fa fa-fw fa-lg fa-trash"></i> Delete Field
                                        <!-- {{itr.fieldName}} -->
                                    </button>

                                    <button class="btn btn-sm btn-warning marginLR5" *ngIf="!itr.status"
                                        (click)="removeRow(fieldIndex,'undo','field',null)"
                                        style="margin-top: 20px;margin-bottom: 11px;width:189px;"><i style="font-size: 18px;" class="fa fa-fw fa-lg fa-undo"></i> Undo
                                        <!-- {{itr.fieldName}} -->
                                    </button>
                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin-top: 8px;text-align: center;">
                                    <button class="btn btn-sm marginLR5" *ngIf="itr.module=='ADDRESS'" 
                                        (click)="configureFieldOptions(itr,fieldIndex)" style="width:189px;background-color: rgb(255,131,0);color:white;"><i
                                            class="fa fa-gear"></i> Configure Field
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
    </div>
    <!-- Add new section tab-->
    <div class="content-body padding-top-20 padding-bottom-20" style="padding-bottom: 0px !important;">
        <div class="row" [sortablejs]="customFieldConfig.sections" [sortablejsOptions]="draggableOptions">
            <div class="container col-md-12 col-sm-12 col-xs-12" style="padding: 0px;"
                *ngFor="let sectionItr of customFieldConfig.sections  ; let sectionIndex=index" [class.draggable]="true"
                [class.disabled]="false">
                <div class="panel panel-success" style="display: grid;">
                    <div style="padding: 15px;">
                        <div class="col-lg-4 form-group">
                            <input type="text" [(ngModel)]="sectionItr.sectionName" class="form-control" required onkeypress="return /[0-9a-zA-Z- ]/i.test(event.key)" 
                                placeholder="Enter the section name" (keyup)="disableButton()"
                                style="padding-left:5px;">
                        </div>
                        <div class="col-lg-4 form-group">
                            <select [(ngModel)]="sectionItr.deviceType" class="form-select form-select-sm" placeholder="Device type"
                                (change)="disableButton()" #deviceTypeModel="ngModel" name="deviceTypeModel"
                                id="deviceTypeModel">
                                <option *ngFor="let dt of deviceTypes; let j=index" [ngValue]="dt.value">{{dt.name}}
                                </option>
                            </select>
                        </div>
                        <div class="col-lg-4 form-group">
                            <input type="text" [(ngModel)]="sectionItr.titleBgColor" class="form-control" required
                                placeholder="Enter header bg color" (keyup)="disableButton()" style="padding-left:5px;">
                        </div>
                        <div class="col-lg-4 form-group">
                            <input type="text" [(ngModel)]="sectionItr.titleTextColor" class="form-control" required
                                placeholder="Enter header text color" (keyup)="disableButton()"
                                style="padding-left:5px;">
                        </div>
                        <div class="col-lg-4 form-group" style="padding-top: 50px;text-align: center;">
                            <button class="btn btn-sm btn-primary  marginLR5" style="margin-left:5px;margin-right: 5px;"
                                (click)="addNewRow('sectionField',sectionIndex)">
                                <span>
                                    <i class="fa fa-plus-circle" style="margin-top:6px;color:#fff;"></i> Add New
                                    Field</span>
                            </button>

                            <button class="btn btn-sm btn-danger marginLR5" *ngIf="sectionItr.status"
                                (click)="removeRow(null,'delete','section',sectionIndex)"
                                style="margin-right: 5px;margin-left:5px;"><i class="fa fa-fw fa-lg fa-trash"></i>
                                Delete Section
                                <!-- {{itr.fieldName}} -->
                            </button>

                            <button class="btn btn-sm btn-warning marginLR5" *ngIf="!sectionItr.status"
                                (click)="removeRow(null,'undo','section',sectionIndex)"
                                style="margin-right: 5px;margin-left:5px;"><i class="fa fa-fw fa-lg fa-undo"></i> Undo
                                <!-- {{itr.fieldName}} -->
                            </button>
                        </div>
                    </div>
                    <div class="panel-body" style="margin-top: 10px;">
                        <div class="content-body padding-top-20 padding-bottom-20"
                            style="padding-left: 0px;padding-right: 0px;">
                            <div class="row">
                                <div class="col-md-12 col-sm-12 col-xs-12"
                                    style="padding-left: 0px;padding-right: 0px;">
                                    <table class="table table-border-yellow">
                                        <tbody [sortablejs]="sectionItr.customFields "
                                            [sortablejsOptions]="draggableOptions">
                                            <tr *ngFor="let itr of sectionItr.customFields  ; let fieldIndex_section=index"
                                                [class.draggable]="true" [class.disabled]="false">
                                                <td>
                                                    <div class="form-group col-lg-3 col-md-4 col-sm-4 col-xs-12">
                                                        <input [(ngModel)]="itr.fieldName" type="text" onkeypress="return /[0-9a-zA-Z- ]/i.test(event.key)"  
                                                            class="form-control" required placeholder="Field name"
                                                            (blur)="checkUniqueField(itr.fieldName,sectionIndex)"
                                                            (keyup)="disableButton()" #fieldNameModel="ngModel"
                                                            name="fieldNameModel" id="fieldNameModel">
                                                        <p [hidden]="fieldNameModel.valid || fieldNameModel.pristine"
                                                            class="danger-text">*required</p>
                                                    </div>
                                                    <div class="form-group col-lg-3 col-md-4 col-sm-4 col-xs-12">
                                                        <select [(ngModel)]="itr.fieldType" class="form-select form-select-sm"
                                                            required placeholder="Field type" (change)="disableButton()"
                                                            #fieldTypeModel="ngModel" name="fieldTypeModel"
                                                            id="fieldTypeModel">
                                                            <!--<option *ngIf="itr.fieldType!=null">{{itr.fieldType}}
                                                            </option>-->
                                                            <option [hidden]="moduleId!='REFRACTION'" *ngFor="let ft of refractionFieldTypes; let j=index">{{ft}}</option><!--show field types only for refraction module-->
                                                            <option [hidden]="moduleId=='REFRACTION'" *ngFor="let ft of fieldTypes; let j=index">{{ft}}</option><!--show field types other than for refraction module-->
                                                        </select>
                                                        <p [hidden]="fieldTypeModel.valid || fieldTypeModel.pristine"
                                                            class="danger-text">*required</p>
                                                    </div>
                                                    <div *ngIf="itr.fieldType=='Drop Down' || itr.fieldType=='Check Box' || itr.fieldType=='Radio Button' || itr.fieldType=='Multiselect'"
                                                        class="form-group col-lg-3 col-md-4 col-sm-4 col-xs-12">
                                                        <input type="text" class="form-control"
                                                            placeholder="Enter comma seperated values"
                                                            [(ngModel)]="itr.fieldOptions" (keyup)="disableButton()"
                                                            required>
                                                    </div>
                                                    <div class="form-group col-lg-3 col-md-4 col-sm-4 col-xs-12">
                                                        <div class="chiller_cb">
                                                            <input
                                                                id="isMandatory_{{sectionIndex}}_{{fieldIndex_section}}"
                                                                [(ngModel)]="itr.isMandatory"
                                                                name="isMandatory_{{sectionIndex}}_{{fieldIndex_section}}"
                                                                type="checkbox" class="form-control" />
                                                            <label style="font-weight: normal;"
                                                                for="isMandatory_{{sectionIndex}}_{{fieldIndex_section}}">Mandatory</label>
                                                            <span></span>
                                                        </div>
                                                        <!--   <tr><td>Mandatory</td>&nbsp;<td><input type="checkbox" [(ngModel)]="itr.isMandatory" class="form-control"/></td></tr>-->
                                                    </div>
                                                    <div class="form-group col-lg-3 col-md-4 col-sm-4 col-xs-12">
                                                        <input type="text" [(ngModel)]="itr.regex" placeholder="Regex"
                                                            class="form-control" />
                                                    </div>
                                                    <div class="form-group col-lg-3 col-md-4 col-sm-4 col-xs-12">
                                                        <input type="number" [(ngModel)]="itr.minLength"
                                                            class="form-control" min=0 placeholder="Min length"
                                                            (keyup)="validateLength(itr.minLength,itr.maxLength)" />
                                                    </div>
                                                    <div class="form-group col-lg-3 col-md-4 col-sm-4 col-xs-12">
                                                        <input type="number" [(ngModel)]="itr.maxLength"
                                                            class="form-control" min=0 placeholder="Max length"
                                                            (keyup)="validateLength(itr.minLength,itr.maxLength)" />
                                                    </div>
                                                    <div class="form-group col-lg-3 col-md-4 col-sm-4 col-xs-12"
                                                        *ngIf="moduleId=='Patient' || moduleId=='ADDRESS'">
                                                        <div class="chiller_cb">
                                                            <input
                                                                id="isSearchable_{{sectionIndex}}_{{fieldIndex_section}}"
                                                                [(ngModel)]="itr.isSearchable"
                                                                name="isSearchable_{{sectionIndex}}_{{fieldIndex_section}}"
                                                                type="checkbox" class="form-control" />
                                                            <label style="font-weight: normal;"
                                                                for="isSearchable_{{sectionIndex}}_{{fieldIndex_section}}">Searchable</label>
                                                            <span></span>
                                                        </div>
                                                    </div>
                                                    <div class="form-group col-lg-3 col-md-4 col-sm-4 col-xs-12"
                                                        *ngIf="moduleId=='Patient'">
                                                        <div class="chiller_cb">
                                                            <input
                                                                id="isConfidential_{{sectionIndex}}_{{fieldIndex_section}}"
                                                                [(ngModel)]="itr.isConfidential"
                                                                name="isConfidential_{{sectionIndex}}_{{fieldIndex_section}}"
                                                                type="checkbox" class="form-control" />
                                                            <label style="font-weight: normal;"
                                                                for="isConfidential_{{sectionIndex}}_{{fieldIndex_section}}">Confidential</label>
                                                            <span></span>
                                                        </div>
                                                    </div>
                                                    <div class="form-group col-lg-3 col-md-4 col-sm-4 col-xs-12"
                                                        *ngIf="moduleId=='Patient'">
                                                        <div class="chiller_cb">
                                                            <input
                                                                id="isUnique{{sectionIndex}}_{{fieldIndex_section}}"
                                                                [(ngModel)]="itr.isUnique"
                                                                name="isUnique{{sectionIndex}}_{{fieldIndex_section}}"
                                                                type="checkbox" class="form-control" (ngModelChange)="isDuplicatePresent(itr)"/>
                                                            <label style="font-weight: normal;"
                                                                for="isUnique{{sectionIndex}}_{{fieldIndex_section}}">Unique Value</label>
                                                            <span></span>
                                                        </div>
                                                    </div>
                                                    <div class="form-group col-lg-3 col-md-4 col-sm-4 col-xs-12"
                                                        *ngIf="moduleId=='EXPERT_FUNDUS' || moduleId == 'REFRACTION' ">
                                                        <div class="chiller_cb">
                                                            <input
                                                                id="includeInReport_{{sectionIndex}}_{{fieldIndex_section}}"
                                                                [(ngModel)]="itr.includeInReport"
                                                                name="includeInReport_{{sectionIndex}}_{{fieldIndex_section}}"
                                                                type="checkbox" class="form-control" />
                                                            <label style="font-weight: normal;"
                                                                for="includeInReport_{{sectionIndex}}_{{fieldIndex_section}}">Include
                                                                In Report</label>
                                                            <span></span>
                                                        </div>
                                                    </div>
                                                    <div class="form-group col-lg-3 col-md-4 col-sm-4 col-xs-12"
                                                        *ngIf="moduleId=='Patient'"><select
                                                            [(ngModel)]="itr.fieldIdentity" class="form-select form-select-sm"
                                                            placeholder="Field identity">
                                                            <option *ngFor="let fi of fieldIdentities; let j=index"
                                                                [ngValue]="fi.value">{{fi.name}}</option>
                                                        </select>
                                                    </div>
                                                    <div class="form-group col-lg-3 col-md-4 col-sm-4 col-xs-12"
                                                        *ngIf="moduleId=='REFRACTION'"><select
                                                            [(ngModel)]="itr.fieldIdentity" class="form-select form-select-sm"
                                                            placeholder="Field identity">
                                                            <option *ngFor="let fi of refractionFieldIdentities; let j=index"
                                                                [ngValue]="fi.value">{{fi.name}}</option>
                                                        </select>
                                                    </div>
                                                     <div class="form-group col-lg-3 col-md-4 col-sm-4 col-xs-12"
                                                        *ngIf="moduleId=='Referral'"><select
                                                            [(ngModel)]="itr.fieldIdentity" class="form-select form-select-sm"
                                                            placeholder="Field identity">
                                                            <option *ngFor="let fi of spectacleOrderFieldIdentities; let j=index"
                                                                [ngValue]="fi.value">{{fi.name}}</option>
                                                        </select>
                                                    </div>
                                                    <div class="form-group col-lg-3 col-md-4 col-sm-4 col-xs-12"
                                                    *ngIf="moduleId=='DOAAS'"><select
                                                        [(ngModel)]="itr.fieldIdentity" class="form-select form-select-sm"
                                                        placeholder="Field identity">
                                                        <option *ngFor="let fi of teleOptometryFieldIdentities; let j=index"
                                                            [ngValue]="fi.value">{{fi.name}}</option>
                                                    </select>
                                                </div>
                                                    <div class="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin-top: 18px;text-align: center;">
                                                        <button class="btn btn-sm btn-danger marginLR5"
                                                            *ngIf="itr.status"
                                                            (click)="removeRow(fieldIndex_section,'delete','field_section',sectionIndex)"
                                                            style="margin-right: 5px;margin-left:5px;width:189px"><i
                                                                class="fa fa-fw fa-lg fa-trash"></i>
                                                            Delete Field
                                                            <!-- {{itr.fieldName}} -->
                                                        </button>

                                                        <button class="btn btn-sm btn-warning marginLR5"
                                                            *ngIf="!itr.status"
                                                            (click)="removeRow(fieldIndex_section,'undo','field_section',sectionIndex)"
                                                            style="margin-right: 5px;margin-left:5px;"><i
                                                                class="fa fa-fw fa-lg fa-undo"></i> Undo
                                                            <!-- {{itr.fieldName}} -->
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--Submit button-->
        </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div class="col-xs-12 text-center mTop15"
            *ngIf="customFieldConfig.customFields.length>0 || customFieldConfig.sections.length>0">
            <button style="margin-right: 5px;" [disabled]="disableButtonFlag" class="btn btn-sm btn-success marginLR5"
                (click)="onSubmit()">
                <i class="fa fa-fw fa-lg fa-check-circle"></i> Save Custom Fields</button>
        </div>
    </div>
</div>


<!--start : field configuration popup-->
<div bsModal #configureFieldOptionsPopUp='bs-modal' class="modal fade" [config]="{backdrop: 'static'}" tabindex="-1"
    role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header card-header">
                <label>Field Option Configuration</label>
                <button class="btn btn-sm btn-primary pull-right" style="margin-top:0px"
                    (click)="addNewFieldInConfigureFieldOptions()" [disabled]="isEligibleToSubmit">Add new
                    field</button>
            </div>
            <div class="modal-body" style="padding-top:30px !important;overflow: auto;height: 450px;">
                <table class="table">
                    <tr>
                        <th style="border-top: none !important;">Code</th>
                        <th style="border-top: none !important;">Name</th>
                        <th style="border-top: none !important;" colspan="2">Belongs to</th>
                    </tr>
                    <tr
                        *ngFor="let itrConfigurableFieldOption of configurableFieldOptionList; let configurableFieldIndex=index">
                        <td style="border-top: none !important;"><input type="text" class="form-control"
                                placeholder="Enter code" [(ngModel)]="itrConfigurableFieldOption.id"
                                (keyup)="validateCode(itrConfigurableFieldOption.id)"></td>
                        <td style="border-top: none !important;"><input type="text" class="form-control"
                                placeholder="Enter name" [(ngModel)]="itrConfigurableFieldOption.value"></td>
                        <td style="border-top: none !important;">
                            <select class="form-select form-select-sm" [(ngModel)]="itrConfigurableFieldOption.parentCode">
                                <option *ngFor="let itrBelongsToField of belongsToFieldList"
                                    [ngValue]="itrBelongsToField.code">{{itrBelongsToField.name}}

                                </option>
                            </select>
                        </td>
                        <td style="border-top: none !important;"><button class="btn btn-sm btn-danger" style="margin-left: 25px;"
                                (click)="removeConfigurableFieldOption(configurableFieldIndex)"><i
                                    class="fa fa-trash"></i> Delete</button></td>
                    </tr>
                </table>

            </div>
            <div class="modal-footer">
                <button class="btn btn-sm btn-success" (click)="setConfigurableFieldOption()"
                    [disabled]="isEligibleToSubmit">Set Configuration</button>
                <button class="btn btn-sm btn-danger" (click)="hideConfigureFieldOptionsPopUp()">Cancel</button>
            </div>
        </div>

    </div>
</div>
<!--end : field configuration popup-->